import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M13.624 3.416 7.401 12.75H6.003L2.38 7.422l1.24-.844 3.077 4.525 5.679-8.519z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }